const namespace = 'careplan/'

export const SET_TARGET_OFFICE_ID = namespace + '.SET_TARGET_OFFICE_ID'
export const SET_TARGET_USER_ID = namespace + '.SET_TARGET_USER_ID'
export const SET_TARGET_DATE = namespace + '.SET_TARGET_DATE'
export const SET_STAFFS_LIST = namespace + '.SET_STAFFS_LIST'
export const SET_USERS_LIST = namespace + '.SET_USERS_LIST'
export const SET_PLAN_TO_EDIT = namespace + '.SET_PLAN_TO_EDIT'
